module.exports = __webpack_public_path__ + "img/bg_cheng_pc.4f8ddd3d.png";